/**
 * Pure planning logic for the WorkPreservation source-tree snapshot:
 * tracked + untracked files are included in the archive, while deleted paths
 * are recorded separately for restore-time removal.
 */

export interface GitSurface {
  trackedAndUntracked(): string[];
  deletedSinceHead(): string[];
}

export interface SnapshotFilePlan {
  include: string[];
  deletions: string[];
}

export function planSnapshotFiles(git: GitSurface): SnapshotFilePlan {
  const include = git.trackedAndUntracked();
  const includeSet = new Set(include);
  const deletions = [...new Set(git.deletedSinceHead())].filter((path) => !includeSet.has(path));
  return { include, deletions };
}
